import styles from './BestCard.module.css'
import clsx from 'clsx'
import { BasicStyledComponent, DSBest, UIRatingVariant } from 'shared-definitions/types'
import AppImage from 'shared-components/ui/AppImage'
import ScoreRing from 'shared-components/ui/ScoreRing'
import ScoreStarts from 'shared-components/ui/Score'
import React from 'react'

interface BestCardProps extends BasicStyledComponent {
  item: Pick<DSBest, 'image' | 'score' | 'badge'>
  scoreVariant?: UIRatingVariant
}

interface ScoreProps {
  score: number
  variant: UIRatingVariant
}

const Score: React.VFC<ScoreProps> = ({ score, variant }) => {
  if (variant === 'number') {
    return <ScoreRing className={styles.scoreNumber} score={score} />
  }

  return <ScoreStarts className={styles.scoreStars} score={score} />
}

const BestCard: React.VFC<BestCardProps> = ({ className, item, scoreVariant = 'number' }) => (
  <div className={clsx(styles.imageWrapper, className)}>
    <AppImage
      layout="responsive"
      ratio={{ w: 16, h: 9 }}
      image={item.image}
      sizes={[
        { bp: 'lg', val: 210 },
        { bp: 'sm', val: 'calc(50vw - rem(30))' },
        'calc(100vw - rem(30))',
      ]}
    />
    {item.badge ? (
      <AppImage
        className={styles.badge}
        imageClassName={styles.badgeImage}
        image={item.badge}
        layout="raw"
        sizes={40}
      />
    ) : null}
    {item.score ? <Score score={item.score} variant={scoreVariant} /> : null}
  </div>
)

export default BestCard
